export default __webpack_public_path__ + "static/media/background.597ed030.jpg";